export default "__VITE_ASSET__DnmW6Frz__"